import Typography from '@/common/components/base/typography/Typography';
import useModal from '@/common/hooks/useModal';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Box, Flex } from 'styled-system/jsx';
import WalletAddIcon from '../../assets/icons/walletAdd.svg?react';
import { WalletPayoutType } from '../../queries/walletPeriodSummary/walletPeriodSummaryQuery.type';
import { walletPeriodSummaryQueryOptions } from '../../queries/walletPeriodSummary/walletPeriodSummaryQueryOptions';
import LoadingCreditList from '../loadingCards/LoadingCreditList';
import { default as WalletInvoiceDetailModal } from '../modals/WalletInvoiceDetail';
import CreditCard from '../walletCards/CreditCard';
import WalletEmptyState from '../walletCards/WalletEmptyState';

export default function WalletCreditList(props: {
  year: number;
  month: number;
}) {
  const { year, month } = props;
  const { openModal, open, closeModal } = useModal({});
  const [selectedPayout, setSelectedPayout] = useState<WalletPayoutType | null>(
    null,
  );

  const { data, isError, isPending } = useQuery(
    walletPeriodSummaryQueryOptions({ year, month }),
  );

  const handleOpen = (payout: WalletPayoutType) => {
    setSelectedPayout(payout);
    openModal();
  };

  if (isError) return <Typography> بارگیری با مشکل مواجه شده است! </Typography>;

  return (
    <Flex flexDirection={'column'} gap={16} mt={16}>
      <Flex alignItems={'center'} gap={8} height={26}>
        <WalletAddIcon />
        <Typography textStyle={'h1'} lineHeight={'28px'} color={'black'}>
          واریزی ها
        </Typography>
      </Flex>
      <Flex flexDirection={'column'} gap={12}>
        {!isPending ? (
          data.payouts.map((payout) => {
            return (
              <Box
                key={payout.settlement_id}
                width="100%"
                cursor={'pointer'}
                onClick={() => handleOpen(payout)}
              >
                <CreditCard
                  amount={payout.amount}
                  paymentDate={payout.payment_date}
                />
              </Box>
            );
          })
        ) : (
          <LoadingCreditList />
        )}
      </Flex>

      <WalletInvoiceDetailModal
        closeModal={closeModal}
        open={open}
        payout={selectedPayout}
      />

      {/* no content handling */}
      {!isPending && data.payouts.length <= 0 && (
        <WalletEmptyState
          title={
            data.period.is_current
              ? 'هنوز واریزی برای این دوره ثبت نشده است'
              : 'در این دوره واریزی ثبت نشده است'
          }
        />
      )}
    </Flex>
  );
}
